import { useQueryClient } from '@tanstack/react-query';

export function useHardwarePageMutations() {
  const queryClient = useQueryClient();

  const invalidateHardwareCareHomes = async () => {
    await queryClient.invalidateQueries({ queryKey: ['hardwareCareHomes'] });
  };

  const invalidateHardwareGateways = async () => {
    await queryClient.invalidateQueries({ queryKey: ['hardwareGateways'] });
  };

  const invalidateHardwareAvailableClips = async () => {
    await queryClient.invalidateQueries({ queryKey: ['hardwareAvailableClips'] });
  };

  const invalidateHardwareCareHomeStats = async () => {
    await queryClient.invalidateQueries({ queryKey: ['hardwareCareHomeStats'] });
  };

  return {
    invalidateHardwareCareHomes,
    invalidateHardwareGateways,
    invalidateHardwareAvailableClips,
    invalidateHardwareCareHomeStats,
  };
}

